import React, { createContext, useContext } from "react";

export enum RenderTarget {
  web = 0,
  pdf = 1,
}

const Ctx = createContext<RenderTarget>(RenderTarget.web);

export const RenderTargetProvider = Ctx.Provider;
export const useRenderTarget = () => useContext(Ctx);

export type AnyProps = Record<string, any>;
const EVENT_PROPS = new Set([
  "onClick", // no itx
  "onDoubleClick", // no itx

  "onMouseDown", // no itx
  "onMouseUp", // no itx
  "onMouseMove", // no itx

  "onPointerDown", // no itx
  "onPointerUp", // no itx
  "onPointerMove", // no itx
  "onPointerEnter", // no itx
  "onPointerLeave", // no itx
  "onPointerOver", // no itx
  "onPointerOut", // no itx

  "onWheel", // no itx
  "onKeyDown", // no itx
  "onKeyUp", // no itx

  "onFocus", // no itx
  "onBlur", // no itx

  "onChange", // no itx
  "onInput", // no itx

  "onContextMenu", // no itx

  "onDrag", // no itx
  "onDragStart", // no itx
  "onDragEnd", // no itx
  "onDragOver", // no itx
  "onDrop", // no itx
]);

export function stripEventsIfPdf<P extends AnyProps>(props: P, target: RenderTarget): P {
  if (target === RenderTarget.web) {
    return props;
  }

  const out: AnyProps = {};
  for (const k in props) {
    if (!EVENT_PROPS.has(k)) {
      out[k] = (props as AnyProps)[k];
    }
  }

  return out as P;
}
